<div class="ws-request-status-wrapper">
  <button type="button" class="ws-request-status-wrapper__close" (click)="onClickedClose('close')">
    <mat-icon>close</mat-icon>
  </button>

  <div class="ws-request-status-wrapper__body">
    <div class="ws-request-status-wrapper__icon" aria-hidden="true">
      <mat-icon>check_circle</mat-icon>
    </div>
    <h2 class="ws-request-status-wrapper__title">Request submitted successfully</h2>
    <p class="ws-request-status-wrapper__text">
      Your workshop / site visit schedule request has been sent.
    </p>
    <button type="button" class="ws-request-status-wrapper__link" (click)="onClickViewStatus()">
      View status
    </button>
  </div>
</div>
